<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    @new-confirm-and-add-other-action="createEntryAndAddOther"
    :saveAndAddOtherButtonEnabled="true"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :storageAdjustment="storageAdjustment"
        :modelNameSingular="modelNameSingular"
        :isLoss="isLoss"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    storageAdjustment: Object,
    modelNameSingular: String,
    isLoss: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.loading = true;
      
      if (this.storageAdjustment.isStockEntryType) {
        this.$apollo
        .query({
          query: NEW_ENTRY_STORAGE_ADJUSTMENT_ITEM_QUERY,
          variables: {
            storageId: this.storageAdjustment.storageId
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          //console.log("itens for stock adjustment", response.data.accountContext.entryStorageAdjustmentItem);
          this.entry = response.data.accountContext.entryStorageAdjustmentItem;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
      } else {
        if(this.storageAdjustment.removeFromStorage){
          this.$apollo
          .query({
            query: NEW_EXIT_STORAGE_ADJUSTMENT_ITEM_QUERY,
            variables: {
              storageId: this.storageAdjustment.storageId
            },
            fetchPolicy: "no-cache"
          })
          .then(response => {
            // console.log("itens for stock adjustment", response);
            this.entry = response.data.accountContext.exitStorageAdjustmentItem;
            this.extraData = response.data;
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
        }else{
          this.$apollo
          .query({
            query: NEW_DUMMY_EXIT_STORAGE_ADJUSTMENT_ITEM_QUERY,
            variables: {
              storageId: this.storageAdjustment.storageId
            },
            fetchPolicy: "no-cache"
          })
          .then(response => {
            // console.log("itens for stock adjustment", response);
            this.entry = response.data.accountContext.dummyExitStorageAdjustmentItem;
            this.extraData = response.data;
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
        }
      }
      
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.$refs.baseNew.closeDialog();
        this.$emit("entry-created", this.entry);
        this.resetForm();
        return true;
      } else {
        return false;
      }
    },
    createEntryAndAddOther: function() {
      if (this.createEntry()){
        this.loadServerEntry();
        this.$refs.baseNew.newDialog = true;
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const NEW_ENTRY_STORAGE_ADJUSTMENT_ITEM_QUERY = gql `
query($storageId: ID!) {
  accountContext {
    entryStorageAdjustmentItem {
      id
      quantity
      price
      unitPrice
      hasLot
      enabledLots
      isNewItemInStorage
      itemId
      item {
        id
        name
        unit {
          id
          name
        }
      }      
      entryMovementItemLotsAttributes{
        id
        isNewLot
        name
        lotNumber
        dueDate
        manufacturingDate        
        quantity
      }      
      packagingId
      packaging {
        id
        name
        unitName
        text
        size
      }
      validations
    }
    availableItemsForStorage(storageId: $storageId) {
      id
      name
      unit {
        id
        name
      }
      brand {
        id
        name
      }
      typeText
    }
  }
}
`;

const NEW_EXIT_STORAGE_ADJUSTMENT_ITEM_QUERY = gql `
query($storageId: ID!) {
  accountContext {
    exitStorageAdjustmentItem {
      id
      quantity      
      itemId
      item {
        id
        name
        unit {
          id
          name
        }
      }       
      exitMovementItemLotsAttributes{
        quantity
        isNewLot       
        name
        lotNumber
        dueDate
        manufacturingDate
      }
      packagingId
      packaging {
        id
        name
        unitName
        text
        size
      }
      validations
    }
    availableItemsForStorage(storageId: $storageId) {
      id
      name
      unit {
        id
        name
      }
      brand {
        id
        name
      }
      typeText
    }
  }
}
`;

const NEW_DUMMY_EXIT_STORAGE_ADJUSTMENT_ITEM_QUERY = gql `
query($storageId: ID!) {
  accountContext {
    dummyExitStorageAdjustmentItem {
      id
      quantity      
      itemId
      item {
        id
        name
        unit {
          id
          name
        }
      }
      dummyExitMovementItemLotsAttributes{
        quantity
        isNewLot       
        name
        lotNumber
        dueDate
        manufacturingDate
      }
      packagingId
      packaging {
        id
        name
        unitName
        text
        size
      }
      validations
    }
    availableItemsForStorage(storageId: $storageId) {
      id
      name
      unit {
        id
        name
      }
      brand {
        id
        name
      }
      typeText
    }
  }
}
`;

</script>

<style scoped></style>
